import { render, staticRenderFns } from "./NextPrevArticleModule.vue?vue&type=template&id=5a645513&"
import script from "./NextPrevArticleModule.ts?vue&type=script&lang=ts&"
export * from "./NextPrevArticleModule.ts?vue&type=script&lang=ts&"
import style0 from "./NextPrevArticleModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports